import { enableProdMode, isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import { environment } from 'environments/environment';

if (environment.enableSentry && !isDevMode()) {
  enableProdMode();

  const dsn = environment.SENTRY_DSN;

  Sentry.init({
    dsn: dsn,
    environment: environment.production ? 'Production' : 'Development',
    release: environment.VERSION,
    integrations: [
      Sentry.browserTracingIntegration()
      // Sentry.replayIntegration({
      //   maskAllText: false,
      //   blockAllMedia: true,
      //   stickySession: true
      // })
    ],
    tracesSampleRate: 0.1,
    // replaysSessionSampleRate: 0,
    // replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
      /ExpressionChangedAfterItHasBeenCheckedError:.*/g,
      /.*Unexpected token.*/g,
      /.*SyntaxError.*/g,
      // /.*422 Unprocessable Content/gi,
      // /.*401 Unauthorized/gi,
      // /.*Token not provided.*/g,
      // /.*Wrong number of segments.*/gi,
      // /.*Failed to initialize WebGL.*/gi,
      /.*TypeError: Cannot read property .*removeControl.*/gi,
      /https\.fcmregistrations\.googleapis\.com/gi,
      /.*LngLatLike.* argument must be specified as a LngLat/gi,
      /.*FirebaseError.*/gi,
      /.*Uncaught.*cloud.*oauth2.*refresh.*/gi,
      /.*ChunkLoadError.*/gi,
      /.*status.*0.*/gi,
      /startCleanup: Page \d+ is currently rendering.*/gi,
      /.*Failed to fetch dynamically imported module:*/gi,
      /.*Failed to load module script:*/gi,
      /.*error loading dynamically imported module*/gi,
      /.*Invalid LngLat object: (NaN, NaN)*/gi,
      /NullInjectorError: No provider for .*!/i,
      /Invalid or corrupted PDF file*/gi,
      /Invalid PDF structure*/gi,
      /.*Refresh token is required*/gi
    ]
  });
}
try {
  const link = document.querySelector("link[rel='icon']");
  if (link instanceof HTMLLinkElement && link.href) {
    link.href = environment.FAVICON;
  }
} catch (error) {
  console.error(error);
}

window.addEventListener('unhandledrejection', (event) => {
  const msg = String(event.reason?.message || '');
  if (msg.includes('Failed to fetch dynamically imported module') || msg.includes('ChunkLoadError') || msg.includes('Importing a module script failed')) {
    window.location.reload();
  }
});

window.addEventListener('error', (event: ErrorEvent) => {
  const msg = String(event.message || '');
  if (msg.includes('Failed to fetch dynamically imported module') || msg.includes('ChunkLoadError') || msg.includes('Importing a module script failed')) {
    window.location.reload();
  }
});

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
